import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"more"}/>
}
